module.exports = __webpack_public_path__ + "static/ninja-the-most-dangerous-game-a0a8ff804556f40df5364ca7e1e82540.jpg";